import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { OdlComponent } from './odl/odl.component';
import { OdlEditComponent } from './odl-edit/odl-edit.component';
import { OdlAddnewComponent } from './odl-addnew/odl-addnew.component';
import { OdlAdminComponent } from './odl-admin/odl-admin.component';
import { OdlAdminMezziComponent } from './odl-admin/mezzi/mezzi.component';
import { OdlAdminAutistiComponent } from './odl-admin/autisti/autisti.component';
import { OdlAdminUtentiComponent } from './odl-admin/utenti/utenti.component';
import { OdlAdminOrdiniComponent } from './odl-admin/ordini/ordini.component';
import { OdlStatsReportComponent } from './layout/odl-stats-report/odl-stats-report.component';
import { OdlStatsComponent } from './odl-stats/odl-stats.component';
import { LoginComponent } from './login/login.component';
import { redirectLoggedInTo, redirectUnauthorizedTo, AngularFireAuthGuard } from '@angular/fire/auth-guard';


const redirectLoggedInToRoot = () => redirectLoggedInTo(['/']);
const redirectUnauthrizedToLogin =() => redirectUnauthorizedTo(['/login']);

const routes: Routes = [
    {
        path: '',
        canActivate: [AngularFireAuthGuard],
        data: {authGuardPipe: redirectUnauthrizedToLogin},
        children: [
            { path: '', redirectTo: '/schedule', pathMatch: 'full' },
            { path: 'schedule', component: OdlComponent, pathMatch: 'full', },
            { path: 'schedule/addnew', component: OdlAddnewComponent, },
            { path: 'schedule/:id', component: OdlEditComponent, },
            { path: 'report', redirectTo: '/report/2010', pathMatch: 'full', },
            { path: 'report/:year', component: OdlStatsComponent, },
            {
                path: 'admin', component: OdlAdminComponent, children: [
                    { path: 'mezzi', component: OdlAdminMezziComponent, },
                    { path: 'autisti', component: OdlAdminAutistiComponent, },
                    { path: 'utenti', component: OdlAdminUtentiComponent, },
                    { path: 'ordini', component: OdlAdminOrdiniComponent, },
                ]
            },
        ]
    },
    {
        path: 'login',
        component: LoginComponent,
        canActivate: [AngularFireAuthGuard],
        data: {authGuardPipe: redirectLoggedInToRoot},
    }
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule]
})
export class AppRoutingModule { }
